import { render, staticRenderFns } from "./DeleteWoWExe.vue?vue&type=template&id=162f26ff&"
import script from "./DeleteWoWExe.vue?vue&type=script&lang=ts&"
export * from "./DeleteWoWExe.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports